// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_ACCOUNT_EXPENSE, ACCOUNT_EXPENSE, EDIT_ACCOUNT_EXPENSE, GET_ACCOUNT_EXPENSE, DELETE_ACCOUNT_EXPENSE } from '../../../../common/constant'

export const actionAccountExpense = createAsyncThunk('appAccountExpense/actionAccountExpense', async (params, thunkAPI) => {
    return await post(ACCOUNT_EXPENSE, params, thunkAPI)
})

export const actionAddAccountExpense = createAsyncThunk('appAccountExpense/actionAddAccountExpense', async (params, thunkAPI) => {
    return await put(ADD_ACCOUNT_EXPENSE, params, thunkAPI)
})

export const actionGetAccountExpense = createAsyncThunk('appAccountExpense/actionGetAccountExpense', async (params, thunkAPI) => {
    return await post(GET_ACCOUNT_EXPENSE, params, thunkAPI)
})

export const actionEditAccountExpense = createAsyncThunk('appAccountExpense/actionEditAccountExpense', async (params, thunkAPI) => {
    return await post(EDIT_ACCOUNT_EXPENSE, params, thunkAPI)
})

export const actionDeleteAccountExpense = createAsyncThunk('appAccountExpense/actionDeleteAccountExpense', async (params, thunkAPI) => {
    return await post(DELETE_ACCOUNT_EXPENSE, params, thunkAPI)
})

export const appAccountExpenseSlice = createSlice({
    name: 'appAccountExpense',
    initialState: {
        //list
        loading: false,
        accountExpense: null,

        //add
        loadingAdd: false,
        addAccountExpense: null,

        //get
        loadingGet: false,
        getAccountExpense: null,

        //edit
        loadingEdit: false,
        editAccountExpense: null,

        //delete
        loadingDelete: false,
        deleteAccountExpense: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetAccountExpenseResponse: (state) => {
            state.accountExpense = null
        },
        resetAddAccountExpenseResponse: (state) => {
            state.addAccountExpense = null
        },
        resetGetAccountExpenseResponse: (state) => {
            state.getAccountExpense = null
        },
        resetEditAccountExpenseResponse: (state) => {
            state.editAccountExpense = null
        },
        resetAccountExpenseDeleteResponse: (state) => {
            state.deleteAccountExpense = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionAccountExpense.pending, (state) => {
                state.loading = true
            })
            .addCase(actionAccountExpense.fulfilled, (state, action) => {
                state.loading = false
                state.accountExpense = action.payload
            })
            .addCase(actionAccountExpense.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddAccountExpense.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddAccountExpense.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addAccountExpense = action.payload
            })
            .addCase(actionAddAccountExpense.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetAccountExpense.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetAccountExpense.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getAccountExpense = action.payload
            })
            .addCase(actionGetAccountExpense.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditAccountExpense.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditAccountExpense.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editAccountExpense = action.payload
            })
            .addCase(actionEditAccountExpense.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteAccountExpense.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteAccountExpense.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteAccountExpense = action.payload
            })
            .addCase(actionDeleteAccountExpense.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetAccountExpenseResponse, resetAddAccountExpenseResponse, resetGetAccountExpenseResponse, resetEditAccountExpenseResponse, resetAccountExpenseDeleteResponse } = appAccountExpenseSlice.actions

export default appAccountExpenseSlice.reducer